import { Spinner, useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const MainBalancePending = () => {
  const { t } = useTranslation();
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });

  //ready,pending
  const isTransferInGameState = useSelector(
    (state) => state.isTransferInGameState
  );

  const toast = useToast();

  useEffect(() => {
    if (isTransferInGameState === "pending") {
      toast({
        title: i18n_common("提醒您"),
        description: i18n_common("我們正在為您處理入鈔轉點中"),
        status: "info",
        id: "pending",
        icon: <Spinner />,
        duration: 9000000,
        isClosable: true,
        position: "top",
      });
    } else if (isTransferInGameState === "ready") {
      toast.close("pending");
    }
  }, [toast, isTransferInGameState]);

  return null;
};

export default MainBalancePending;
